/* Copyright Epoq Legal Ltd 2009-2015 */

//needed to support javascript changes in separate sites
var UserDocs = (typeof UserDocs == "undefined") ? {} : UserDocs;

$(function(){